import { useOnlineStatus } from '../../hook/use-online-status';
import './no-network-connection.css';

export const NoNetworkConnection = () => {
    const isOnline = useOnlineStatus();

    if(!isOnline) return <p className="no-network-connection"><strong>Nincs internetkapcsolat.</strong></p>;
    else return null;

}